function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { forwardRef, useState, useEffect } from "react";
import { Container, Row, Col, Table } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Statistic, Image, message } from 'antd';
import CashierTransactionsList from "./CashierTransactionsList";
import Common from "./includes/Common";
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import Moment from "react-moment";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CashierReport = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var customer = _ref.customer;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      postPaidAmount = _useState2[0],
      setPostPaidAmount = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCash = _useState4[0],
      setTotalCash = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      totalAmount = _useState6[0],
      setTotalAmount = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      customers = _useState8[0],
      setCustomers = _useState8[1];

  var _useState9 = useState(moment().startOf('day').format()),
      _useState10 = _slicedToArray(_useState9, 2),
      from = _useState10[0],
      setFrom = _useState10[1];

  var _useState11 = useState(moment().endOf('day').format()),
      _useState12 = _slicedToArray(_useState11, 2),
      to = _useState12[0],
      setTo = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      dataChanged = _useState14[0],
      setDataChanged = _useState14[1];

  var _useState15 = useState(true),
      _useState16 = _slicedToArray(_useState15, 2),
      isDataLoading = _useState16[0],
      setIsDataLoading = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      deptRevenue = _useState18[0],
      setDeptRevenue = _useState18[1];

  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getdailycash/' + Common.currentUser.id)]).then(function (response) {
      setIsDataLoading(false);

      if (response[0].data.status == 200) {
        setCustomers(response[0].data.customers);
      }

      if (response[1].data.status == 200) {
        setTotalCash(response[1].data.totalCash);
        setTotalAmount(response[1].data.totalAmount);
        setPostPaidAmount(response[1].data.totalPostPaid);
        var nr = [];
        var ar1 = response[1].data.deptRevenue.filter(function (d) {
          return d.label == "CON";
        });
        var ar2 = response[1].data.deptRevenue.filter(function (d) {
          return d.label != "CON";
        });
        var totalCons = 0;
        ar1.forEach(function (ar) {
          totalCons += ar.revenue;
        });
        var cr = [{
          label: "CON",
          revenue: totalCons
        }];
        nr = cr.concat(ar2);
        setDeptRevenue(nr);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
      message.error({
        content: 'Une erreur est survenue ' + error.toString(),
        delay: 4
      });
    });
  }, [dataChanged, from, to]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      ref: ref,
      id: "printable",
      style: {
        padding: "38px"
      },
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
        style: {
          padding: "18px 0px 18px 0px",
          textAlign: "center"
        },
        children: /*#__PURE__*/_jsxs(ARow, {
          children: [/*#__PURE__*/_jsx(ACol, {
            span: 6,
            children: /*#__PURE__*/_jsx(Image, {
              width: "100%",
              preview: false,
              src: "/drawables/logo_sos.jpeg"
            })
          }), /*#__PURE__*/_jsx(ACol, {
            span: 16,
            offset: 2,
            children: /*#__PURE__*/_jsx("h4", {
              style: {
                textAlign: "center",
                marginTop: '40px',
                color: "#EEE",
                background: "#2A4294",
                padding: "18px 10px",
                borderRadius: "7px"
              },
              children: /*#__PURE__*/_jsx("b", {
                children: "RAPPORT DE CAISSE"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ARow, {
        children: /*#__PURE__*/_jsx(ACol, {
          style: {
            fontWeight: "bold"
          },
          children: /*#__PURE__*/_jsx(Moment, {
            date: from,
            format: "DD/MM/YYYY"
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(ARow, {
        children: [/*#__PURE__*/_jsx(ACol, {
          lg: 8,
          span: 8,
          children: /*#__PURE__*/_jsx("div", {
            className: "digitBox",
            style: {
              background: "#FFF2ED",
              borderRadius: "4px",
              padding: "10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Total ce jour",
              value: totalAmount
            })
          })
        }), /*#__PURE__*/_jsx(ACol, {
          lg: 8,
          span: 8,
          children: /*#__PURE__*/_jsx("div", {
            className: "digitBox",
            style: {
              background: "#FFFFF0",
              borderRadius: "4px",
              padding: "10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Cash ce jour",
              value: totalCash
            })
          })
        }), /*#__PURE__*/_jsx(ACol, {
          lg: 8,
          span: 8,
          children: /*#__PURE__*/_jsx("div", {
            className: "digitBox",
            style: {
              background: "#FFF0FE",
              borderRadius: "4px",
              padding: "10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Convention\xE9 ce jour",
              value: postPaidAmount
            })
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(ARow, {
        children: [/*#__PURE__*/_jsx(ACol, {
          span: 8,
          children: deptRevenue.length > 0 && /*#__PURE__*/_jsx(Table, {
            size: "xs",
            responsive: true,
            children: deptRevenue.map(function (dr) {
              return /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: dr.label
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: dr.revenue.toLocaleString("Fr")
                })]
              }, dr.id);
            })
          })
        }), /*#__PURE__*/_jsx(ACol, {
          span: 16,
          children: /*#__PURE__*/_jsx(CashierTransactionsList, {
            dataChanged: dataChanged
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
        children: Common.currentUser.firstname + " " + Common.currentUser.lastname
      })]
    })
  });
});
export default CashierReport;